// API client for chats (direct + group) under /chats.

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

async function request(path, { token, method = "GET", body } = {}) {
  const response = await fetch(`${baseAPI_URL}/chats${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data?.error || "Não foi possível completar a requisição.");
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function listChats(token) {
  const data = await request("", { token });
  return data.chats || [];
}

export async function createChat(token, payload) {
  return request("/create", { token, method: "POST", body: payload });
}

export async function getChat(token, chatCode) {
  return request(`/${chatCode}`, { token });
}

export async function updateChat(token, chatCode, payload) {
  return request(`/${chatCode}`, { token, method: "PUT", body: payload });
}

export async function listMessages(token, chatCode, { limit = 50, before } = {}) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before) params.set("before", before);
  const data = await request(`/${chatCode}/messages?${params}`, { token });
  return data.messages || [];
}

export async function sendTextMessage(token, chatCode, content) {
  return request(`/${chatCode}/messages/text`, {
    token,
    method: "POST",
    body: { content },
  });
}

export async function genPresignedUploadUrl(
  token,
  chatCode,
  { file_type, file_extension, purpose = "message" }
) {
  return request(`/${chatCode}/gen-presigned-upload-url`, {
    token,
    method: "POST",
    body: { file_type, file_extension, purpose },
  });
}

export async function sendImageMessage(token, chatCode, objectKey) {
  return request(`/${chatCode}/messages/image`, {
    token,
    method: "POST",
    body: { object_key: objectKey },
  });
}

export async function removeMessage(token, chatCode, messageId) {
  return request(`/${chatCode}/messages/${messageId}`, {
    token,
    method: "DELETE",
  });
}

export async function addMember(token, chatCode, userId) {
  return request(`/${chatCode}/members`, {
    token,
    method: "POST",
    body: { user_id: userId },
  });
}

export async function removeMember(token, chatCode, memberUserId) {
  return request(`/${chatCode}/members/${memberUserId}`, {
    token,
    method: "DELETE",
  });
}

export async function exitChat(token, chatCode) {
  return request(`/${chatCode}/exit`, { token, method: "POST" });
}

/** Mark the chat as read for the current user (clears unread_count). */
export async function markChatRead(token, chatCode) {
  return request(`/${chatCode}/mark-read`, { token, method: "POST" });
}

/** Upload a file to an S3 presigned URL. */
export async function uploadChatImageToS3(uploadUrl, file) {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!response.ok) {
    throw new Error("Erro ao enviar imagem.");
  }
}
